export default "__VITE_ASSET__Dh1jA$WZ__"